// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__OiD5q","title":"style__title__CJ0Cr","description":"style__description__1HaAL","component":"style__component__-ML2N"};